import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/shared/notification.service';
import { InvoiceOutput } from 'src/app/shared/InvoiceOutput.model';
import { InvoiceOutputService } from 'src/app/shared/InvoiceOutput.service';
import { InvoiceOutputDetail } from 'src/app/shared/InvoiceOutputDetail.model';
import { InvoiceOutputDetailService } from 'src/app/shared/InvoiceOutputDetail.service';
import { Customer } from 'src/app/shared/Customer.model';
import { CustomerService } from 'src/app/shared/Customer.service';
import { Product } from 'src/app/shared/Product.model';
import { ProductService } from 'src/app/shared/Product.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { DownloadService } from 'src/app/shared/Download.service';

@Component({
  selector: 'app-invoice-output-detail-history',
  templateUrl: './invoice-output-detail-history.component.html',
  styleUrls: ['./invoice-output-detail-history.component.css']
})
export class InvoiceOutputDetailHistoryComponent implements OnInit {

  ID: number = environment.InitializationNumber;
  isShowLoading: boolean = false;
  searchString: string = environment.InitializationString;
  dateTimeBegin: Date = new Date();
  dateTimeEnd: Date = new Date();
  total: number = environment.InitializationNumber;
  customerID: number = environment.InitializationNumber;
  dataSource: MatTableDataSource<any>;
  displayColumns: string[] = ['DateCreated', 'CustomerID', 'ProductID', 'Quantity', 'Price', 'Note', 'Total', 'Save'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public InvoiceOutputService: InvoiceOutputService,
    public InvoiceOutputDetailService: InvoiceOutputDetailService,
    public CustomerService: CustomerService,
    public ProductService: ProductService,
    public NotificationService: NotificationService,
    public DownloadService: DownloadService,
  ) {

  }
  ngOnInit(): void {
    this.GetProductToListAsync();
    this.GetCustomerToListAsync();
    this.GetToList();
  }
  onChangeDateTimeBegin(value) {
    this.dateTimeBegin = new Date(value);
  }
  onChangeDateTimeEnd(value) {
    this.dateTimeEnd = new Date(value);
  }
  onSearch() {
    this.GetProductToListAsync();
    //this.GetCustomerToListAsync();
    if (this.searchString.length > 0) {
      this.dataSource.filter = this.searchString.toLowerCase();
    }
    else {
      this.GetToList();
    }
  }
  GetCustomerToListAsync() {
    this.CustomerService.GetAllAndEmptyToListAsync().subscribe(
      res => {
        this.CustomerService.list = (res as Customer[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));
        this.CustomerService.listSearch = this.CustomerService.list;
        this.CustomerService.listSearch001 = this.CustomerService.list;
      },
      err => {
      }
    );
  }
  GetProductToListAsync() {
    this.ProductService.GetByActiveToListAsync(true).subscribe(
      res => {
        this.ProductService.list = (res as Product[]).sort((a, b) => (a.Display > b.Display ? 1 : -1));
      },
      err => {
      }
    );
  }
  GetToList() {
    this.isShowLoading = true;
    this.InvoiceOutputDetailService.GetByCustomerIDAndDateTimeBeginAndDateTimeEndToListAsync(this.customerID, this.dateTimeBegin, this.dateTimeEnd).subscribe(
      res => {
        this.InvoiceOutputDetailService.list = res as InvoiceOutput[];
        if (this.InvoiceOutputDetailService.list) {
          this.dataSource = new MatTableDataSource(this.InvoiceOutputDetailService.list.sort((a, b) => (a.CustomerID > b.CustomerID ? 1 : -1)));
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.total = environment.InitializationNumber;
          for (let i = 0; i < this.InvoiceOutputDetailService.list.length; i++) {
            this.total = this.total + this.InvoiceOutputDetailService.list[i].Total;
          }
        }
        this.isShowLoading = false;
      },
      err => {
        this.isShowLoading = false;
      }
    );
  }
  onChangeDateCreated(element: InvoiceOutputDetail, value) {
    element.DateCreated = new Date(value);
  }
  onFilterCustomer(searchString: string) {
    if (searchString.length > 0) {
      this.CustomerService.listSearch = this.CustomerService.list.filter(item => item.Display && item.Display.length > 0 && item.Display.toLocaleLowerCase().includes(searchString));
    }
    else {
      this.CustomerService.listSearch = this.CustomerService.list;
    }
  }
  onFilterCustomer001(searchString: string) {
    if (searchString.length > 0) {
      this.CustomerService.listSearch001 = this.CustomerService.list.filter(item => item.Display && item.Display.length > 0 && item.Display.toLocaleLowerCase().includes(searchString));
    }
    else {
      this.CustomerService.listSearch001 = this.CustomerService.list;
    }
  }
  onSave(element: InvoiceOutputDetail) {
    console.log(element);
    this.InvoiceOutputDetailService.SaveAsync(element).subscribe(
      res => {
        this.GetToList();
        this.NotificationService.warn(environment.SaveSuccess);
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
      }
    );
  }
  onDelete(element: InvoiceOutputDetail) {
    if (confirm(environment.DeleteConfirm)) {
      this.InvoiceOutputDetailService.RemoveAsync(element.ID).subscribe(
        res => {
          this.GetToList();
          this.NotificationService.warn(environment.DeleteSuccess);
        },
        err => {
          this.NotificationService.warn(environment.DeleteNotSuccess);
        }
      );
    }
  }
  onPrint(element: InvoiceOutputDetail) {
    this.isShowLoading = true;
    this.DownloadService.InvoiceOutputByIDToHTML(element.ParentID).then(
      res => {
        window.open(res.toString(), "_blank");
        this.isShowLoading = false;
      }
    );
  }
  onPrintAll() {
    this.isShowLoading = true;
    this.DownloadService.InvoiceOutputGetByCustomerIDAndDateTimeBeginAndDateTimeEndToHTMLAsync(this.customerID, this.dateTimeBegin, this.dateTimeEnd).subscribe(
      res => {
        window.open(res.toString(), "_blank");
        this.isShowLoading = false;
      },
      err => {
        console.log(err);
        this.isShowLoading = false;
      }
    );
  }
}